const KEY = "pending_intent_v1";

export function savePendingIntent(intent) {
  try {
    if (!intent || typeof intent !== "object") return;
    sessionStorage.setItem(KEY, JSON.stringify(intent));
  } catch (error) {
    console.warn("savePendingIntent failed:", error);
  }
}

export function loadPendingIntent() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.warn("loadPendingIntent failed:", error);
    return null;
  }
}

export function clearPendingIntent() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {
    console.warn("clearPendingIntent failed:", error);
  }
}